module.exports = __webpack_public_path__ + "assets/img/info_fill.f0da3ab1.svg";